import styled from 'styled-components';

const SocialMediaIcons = styled.ul`
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 10px 0 0;

  li {
    float: left;
    font-size: 28px;
    line-height: 28px;

    a {
      color: var(--ipsilum-red);
    }

    &:not(:last-child) {
      margin-right: 15px;
    }
  }
`;

export default {
  SocialMediaIcons
};
